import { QRCodeCanvas } from 'qrcode.react';
import { Copy, Download } from 'lucide-react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '../ui/dialog';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { copyInvitationLink, getInvitationPublicUrl } from '../../lib/sharing';
import { toast } from '../../lib/toast';

function ShareInvitationDialog({
  open,
  onOpenChange,
  invitationId,
  invitationName,
  title = 'Condividi invito',
  description,
}) {
  const url = invitationId ? getInvitationPublicUrl(invitationId) : '';
  const qrId = `qr-${invitationId}`;
  const resolvedDescription = description
    || (invitationName ? `Link per "${invitationName}"` : 'Copia il link o scarica il QR code.');

  const handleCopy = async () => {
    await copyInvitationLink(invitationId);
    toast.success('Link copiato', 'Il link dell\'invito è negli appunti.');
  };

  const handleDownloadQr = () => {
    const canvas = document.getElementById(qrId);
    if (!canvas) return;
    const link = document.createElement('a');
    link.download = `qr-${invitationId}.png`;
    link.href = canvas.toDataURL('image/png');
    link.click();
    toast.success('QR code scaricato', 'L\'immagine è stata salvata sul dispositivo.');
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-sm">
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          <DialogDescription>{resolvedDescription}</DialogDescription>
        </DialogHeader>

        <div className="space-y-4">
          <div className="flex gap-2">
            <Input readOnly value={url} className="text-xs" />
            <Button type="button" variant="outline" size="icon" onClick={handleCopy} aria-label="Copia link">
              <Copy className="h-4 w-4" />
            </Button>
          </div>

          <div className="flex flex-col items-center gap-3 rounded-xl border border-[var(--ba-surface-border)] p-4">
            <QRCodeCanvas id={qrId} value={url} size={180} includeMargin />
            <Button type="button" variant="outline" className="gap-2" onClick={handleDownloadQr}>
              <Download className="h-4 w-4" />
              Scarica QR
            </Button>
          </div>
        </div>

        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>Chiudi</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}

export default ShareInvitationDialog;
